// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oUDF","index":"styles_index__3cIka"};